import React from 'react'
import { useChatWindow } from '@ztechapps/chat.chat-window'

export const GetStartedButton = () => {
  const { toggleShow } = useChatWindow()

  return (
    <a
      href="/"
      onClick={(e) => {
        e.preventDefault()
        return toggleShow()
      }}
      className="getstarted"
      id={'message-us'}
    >
      Message us to get started
    </a>
  )
}
